<p-dropdown
    [disabled]="disabled"
    [options]="ddOptions"
    [(ngModel)]="selectedOption"
    [ngModelOptions]="{ standalone: true }"
    name="episodeOption"
    dataKey="selectMode"
    [showClear]="showClear"
    appendTo="body"
    placeholder="Select Episode"
    (onBlur)="onTouched()"
    (onClick)="onClick()"
    (onClear)="onClear.emit()"
    (onChange)="onSelectEpisodeModeChange($event?.value)">
    <ng-template pTemplate="selectedItem">
        <episode-header-v2
            *ngIf="selectedOption?.episode"
            [episode]="selectedOption.episode"
            [showActionButtons]="false"
            [expandHeaderSmScreen]="false">
        </episode-header-v2>
    </ng-template>

    <ng-template let-item pTemplate="item">
        <i [class]="item.icon"></i><span> {{ item.label }}</span>
    </ng-template>
</p-dropdown>

<p-dialog
    [(visible)]="displaySelectExistingEpisodeDialog"
    (onHide)="closeExistingEpisode()"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    header="Select from Existing Episodes for Selected Patient:"
    appendTo="body"
    [style]="{ 'max-width': '750px', width: '100%', 'max-height': '375px' }">
    <ng-container *miproLoading="episodesLoading">
        <div *ngIf="!(existingEpisodes && existingEpisodes.length)" class="buttons-panel">
            <span class="no-existing-episodes-message">No Existing Episodes for the Patient</span>
        </div>

        <div class="mt-3">
            <div class="existing-episode" *ngFor="let item of existingEpisodes; let i = index">
                <div class="flex">
                    <episode-header-v2
                        class="existing-episode-header mb-2"
                        [episode]="item"
                        [showPlusButton]="false"
                        [showEllipsisButton]="false"
                        [showViewButton]="true"
                        [showHower]="true"
                        (viewEpisode)="emitViewEpisode($event)">
                    </episode-header-v2>
                    <p-radioButton
                        class="margin-left-15"
                        name="episode"
                        [value]="item.id"
                        [(ngModel)]="selectedExistingEpisodeId"></p-radioButton>
                </div>
            </div>
        </div>
    </ng-container>

    <p-footer>
        <div class="flex justify-content-between">
            <div>
                <button
                    [disabled]="loadMoreDisabled"
                    pButton
                    type="button"
                    label="Load More"
                    class="m-button-primary"
                    (click)="loadMore()"></button>
            </div>

            <div>
                <button pButton type="button" label="Cancel" class="p-button-secondary" (click)="cancelExistingEpisode()">
                    <i class="material-icons">clear</i>
                </button>

                <button
                    pButton
                    type="button"
                    [disabled]="!selectedExistingEpisodeId"
                    label="Select Existing Episode"
                    class="m-button-primary"
                    (click)="selectExistingEpisode()"></button>
            </div>
        </div>
    </p-footer>
</p-dialog>

<episode-dialog
    *ngIf="displayAddEpisodeDialog"
    [modal]="true"
    [(visible)]="displayAddEpisodeDialog"
    [patientId]="patientId"
    [isWalkInDraft]="isWalkInDraft"
    (episodeCreated)="closeAddEpisodeDialog($event)"
    (selectExistingEpisode)="closeAddEpisodeDialog($event)"
    [restoreDuplicateCheakState]="restoreDuplicateCheakState"
    [isPrescription]="isPrescription"
    [tempWalkIn]="tempWalkIn"
    [selectedWalkInDate]="selectedWalkInDate"
    (viewEpisode)="viewEpisode.emit($event)"
    (onCancel)="cancelAddEpisode()"
    [assignedClinicianId]="assignedClinicianId"
    [assignedClinicianVisible]="assignedClinicianVisible"
    [incidentRavenIssue]="incidentRavenIssue"
    [incidentNotes]="incidentNotes"
    [createFrom]="createFrom">
</episode-dialog>

<episode-dialog
    *ngIf="displayEditEpisodeDialog"
    [modal]="true"
    [(visible)]="displayEditEpisodeDialog"
    [episodeId]="episodeId"
    [draftedEpisode]="draftedEpisode"
    [isWalkInDraft]="isWalkInDraft"
    [isPrescription]="isPrescription"
    [assignedClinicianId]="assignedClinicianId"
    [assignedClinicianVisible]="assignedClinicianVisible"
    [incidentRavenIssue]="incidentRavenIssue"
    [incidentNotes]="incidentNotes"
    (viewEpisode)="viewEpisode.emit($event)"
    (episodeCreated)="closeEditEpisodeDialog($event)"
    (episodeUpdated)="closeEditEpisodeDialog($event)"
    (onCancel)="cancelEditEpisode($event)">
</episode-dialog>
